import UseCase from "@domain/UseCase";
import DatabaseImportJobRepository from "@domain/repositories/DatabaseImportJobRepository";
import { ImportJob } from "@domain/models/ImportJob";

type Input = ImportJob["id"];

type Output = void;

export class WatchPendingImportJob implements UseCase<Input, Output> {
  constructor(private readonly importJobRepository: DatabaseImportJobRepository) {}

  execute(jobId: ImportJob["id"]) {
    return this.importJobRepository.watchPendingImports(jobId);
  }
}
